import React from 'react';
import format from 'string-template';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import {
    COOKIE_ACCEPTED_KEY,
    COOKIE_ACCEPTED_VALUE
} from '../../../services/header/cookiebanner/constants';
import { BANNER_TYPE_COOKIE } from '../../../services/banner/constants';

import { hideBanner } from '../../../services/banner/actions';

import LocalizedNavLink from '../../router/LocalizedNavLink';
import ButtonComponent from '../../button/ButtonComponent';

import './CookieBannerComponent.scss';

class CookieBannerComponent extends React.Component {
    hideCookieBanner = () => this.props.hideBanner(BANNER_TYPE_COOKIE);

    setCookie = () => {
        try {
            localStorage.setItem(COOKIE_ACCEPTED_KEY, COOKIE_ACCEPTED_VALUE);
            this.hideCookieBanner();
        } catch (err) {
            console.error('localStorage error : ', err);
        }
    };

    isCookiesAccepted = () => {
        try {
            const cookieValue = localStorage.getItem(COOKIE_ACCEPTED_KEY);
            return cookieValue === COOKIE_ACCEPTED_VALUE;
        } catch (err) {
            console.error('localStorage error : ', err);
        }
    };

    render() {
        const { i18n, BRAND_NAME } = this.props;

        return (
            !this.isCookiesAccepted() && (
                <div id="b-cookie">
                    <div className="conteneur conteneur-mobile">
                        {format(i18n.TEXT, BRAND_NAME)}
                        <LocalizedNavLink
                            to={`${PATH.LEGAL_NOTICE_PATH}#cookie-policy`}
                            title={i18n.LINK_TEXT}
                            className="link">
                            {i18n.LINK_TEXT}
                        </LocalizedNavLink>
                        <ButtonComponent
                            text={i18n.BUTTON_TEXT}
                            color="second"
                            onClick={this.setCookie}
                        />
                    </div>
                </div>
            )
        );
    }
}

const mapDispatchToProps = {
    hideBanner
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.feature.header.COOKIE_BANNER,
        BRAND_NAME: state.i18n.common.BRAND_NAME
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CookieBannerComponent);



// WEBPACK FOOTER //
// ./src/components/header/cookiebanner/CookieBannerComponent.js